<template>
  <v-container class="text-left">
    <v-row>
      <v-col cols="10" >
        <v-treeview
          class="elevation-1 bg-blue-grey-lighten-4"
          v-if="treeItems.length"
          v-model:opened="open"
          :items="treeItems"
          item-value="title"
          density="compact"
          activatable
          open-on-click
        >
          <template #prepend="{ item, isOpen }">
            <v-icon v-if="!('file' in item)" :icon="isOpen ? 'mdi-folder-open' : 'mdi-folder'"></v-icon>
            <v-icon v-else :icon="files[item.file ?? ''] || 'mdi-file'"></v-icon>
          </template>
        </v-treeview>
      </v-col>
      <v-col :cols="activateDownload ? 2 : 0">
        <v-btn 
          v-if="activateDownload" 
          class="elevation-10 font-weight-light"
          icon="mdi-download" 
          size="large"
          color="primary"
          variant="tonal"
          @click="downloadZip"
          ></v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import JSZip from 'jszip';

interface Items {
  title: string;
  children?: Items[];
  file?: string;
  [key: string]: any;
}

export default defineComponent({
  name: 'TreeFileView-Componenten',
  props: {
    zipFile: {
      type: File,
      required: true,
    },
    activateDownload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: [] as string[],
      treeItems: [] as Items[],
      files: {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-code-json',
        md: 'mdi-language-markdown',
        pdf: 'mdi-file-pdf-box',
        png: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
        tex: 'mdi-code-tags',
        aux: 'mdi-file-code-outline',
        log: 'mdi-file-document',
        toc: 'mdi-file-document-outline',
        nav: 'mdi-compass-outline',
        snm: 'mdi-file-chart',
        gz: 'mdi-archive',

      } as Record<string, string>,
    };
  },
  methods: {
    async processZip(file: File) {
      const zip = new JSZip();
      const loadedZip = await zip.loadAsync(file);
      const root: Items[] = [];

      for (const relativePath in loadedZip.files) {
        const entry = loadedZip.files[relativePath];

        if (
          relativePath.startsWith('__MACOSX') ||
          relativePath.endsWith('.DS_Store')
        ) {
          continue;
        }

        const parts = relativePath.split('/').filter(Boolean);
        const isDir = entry.dir;
        const isFile = !isDir;

        this.addToTree(root, parts, isFile);
      }

      this.treeItems = root;
      this.open = root.map(item => item.title);
      this.open = [];
    },
    addToTree(tree: Items[], parts: string[], isFile: boolean) {
      const current = parts[0];
      const isLeaf = parts.length === 1;

      let node = tree.find(item => item.title === current);

      if (!node) {
        node = {
          title: current,
          ...(isLeaf && isFile
            ? { file: current.includes('.') ? current.split('.').pop() : undefined }
            : { children: [] }),
        };
        tree.push(node);
      }

      if (!isLeaf && node.children) {
        this.addToTree(node.children, parts.slice(1), isFile);
      }
    },
    downloadZip() {
      const blobUrl = URL.createObjectURL(this.zipFile);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = this.zipFile.name;
      link.click();
      URL.revokeObjectURL(blobUrl); 
    },

  },
  watch: {
    zipFile: {
      immediate: true,
      handler(newFile: File) {
        if (newFile) this.processZip(newFile);
      },
    },
  },
  mounted() {
    if (this.zipFile) this.processZip(this.zipFile);
  },
});
</script>
